module.exports = __webpack_public_path__ + "static/fonts/BMHANNA_11yrs_ttf.ttf?c064e459";